import { motion } from 'framer-motion';
import { Lock, ArrowUpRight } from 'lucide-react';
import { Button } from './ui/button';
import { MainLayout } from './layout/Sidebar';
import { useNavigate } from 'react-router-dom';

export function UpgradePrompt({ feature, currentTier, requiredTier }) {
  const navigate = useNavigate();
  const tierLabel = {
    starter: 'Starter',
    professional: 'Professional',
    enterprise: 'Enterprise',
  };

  return (
    <MainLayout>
      <div className="flex items-center justify-center min-h-[60vh]" data-testid="upgrade-prompt">
        <motion.div
          className="max-w-md text-center"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
        >
          <div className="w-16 h-16 rounded-2xl bg-amber-100 flex items-center justify-center mx-auto mb-6">
            <Lock className="w-7 h-7 text-amber-600" />
          </div>
          <h2 className="text-2xl font-bold text-gray-900 tracking-tight" style={{ fontFamily: 'Outfit' }}>
            Upgrade Required
          </h2>
          <p className="mt-3 text-gray-500 leading-relaxed">
            <span className="font-medium text-gray-700">{feature}</span> is not available on your{' '}
            <span className="font-medium capitalize text-gray-700">{tierLabel[currentTier] || 'Starter'}</span> plan.
            {requiredTier && (
              <> Upgrade to <span className="font-medium text-gray-700">{tierLabel[requiredTier]}</span> or higher to unlock.</>
            )}
          </p>
          <div className="mt-8 flex flex-col gap-3 items-center">
            <Button
              onClick={() => navigate('/subscription')}
              className="bg-[#002FA7] hover:bg-[#001d6e] text-white gap-2 px-6"
              data-testid="upgrade-now-btn"
            >
              Upgrade Now <ArrowUpRight className="w-4 h-4" />
            </Button>
            <button
              onClick={() => navigate(-1)}
              className="text-sm text-gray-400 hover:text-gray-600 transition-colors"
              data-testid="upgrade-go-back-btn"
            >
              Go back
            </button>
          </div>
        </motion.div>
      </div>
    </MainLayout>
  );
}
